function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useImperativeHandle, useState, forwardRef } from 'react';
import PropTypes from 'prop-types';
import { isEmpty, find, noop } from 'lodash';
import SelectField from "../../Form/SelectField/SelectField";
import Icon from "../Icon/Icon";
import "./ActionSelect.scss";
import { jsx as _jsx } from "react/jsx-runtime";
const ActionSelect = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    position = "right",
    actions = [],
    disabled = false,
    flat = true,
    id,
    placeholder = "Take Action",
    label = "Action Select",
    primary = true,
    searchEnabled = false,
    styles = {},
    valueKey = "value",
    labelKey = "label",
    onChange = noop
  } = _ref;
  const [loading, setLoading] = useState(false);
  const [selectedAction, setSelectedAction] = useState(null);
  const options = actions.map(action => _objectSpread(_objectSpread(_objectSpread({}, action), action.icon ? {
    icon: /*#__PURE__*/_jsx(Icon, {
      icon: action.icon,
      className: "mr-1 mb-1"
    })
  } : null), action.description ? {
    description: /*#__PURE__*/_jsx("p", {
      className: "text-xs text-dark-grey font-regular-font ".concat(action.icon && "ml-6"),
      children: action.description
    })
  } : null));
  const doAction = action => {
    if (typeof action.action === "function") {
      setLoading(true);
      const p = action.action();
      Promise.all([p]).then(() => {
        setLoading(false);
      });
    }
  };
  const handleOnChange = val => {
    const action = find(actions, act => act.value === val);
    const selected = isEmpty(action) ? null : action;
    setSelectedAction(selected);
    setTimeout(() => doAction(action), 400);
    onChange(selected);
  };

  // Expose a resetValue method to the parent component
  useImperativeHandle(ref, () => ({
    resetValue: () => setSelectedAction(null)
  }));
  return /*#__PURE__*/_jsx("div", {
    className: "action-select-container ".concat(position),
    children: /*#__PURE__*/_jsx("div", {
      className: "flex text-xs font-heavy-font ".concat(!flat ? "shadow" : ""),
      children: /*#__PURE__*/_jsx(SelectField, {
        tabIndex: 0,
        id: id,
        options: options,
        disabled_prop: loading || disabled,
        loading: loading,
        className: "p-0",
        placeholder: placeholder,
        onChange: handleOnChange,
        searchEnabled: searchEnabled,
        style: styles,
        label: label,
        hideLabel: true,
        valueKey: valueKey,
        labelKey: labelKey,
        value: selectedAction,
        primary: primary
      })
    })
  });
});
ActionSelect.propTypes = {
  actions: PropTypes.array,
  position: PropTypes.oneOf(["right", "left"]),
  disabled: PropTypes.bool,
  flat: PropTypes.bool,
  id: PropTypes.string.isRequired,
  labelKey: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.node,
  label: PropTypes.string,
  primary: PropTypes.bool,
  styles: PropTypes.shape({
    container: PropTypes.object,
    label: PropTypes.object,
    input: PropTypes.object,
    hint: PropTypes.object,
    error: PropTypes.object
  }),
  searchEnabled: PropTypes.bool,
  valueKey: PropTypes.string
};
export default ActionSelect;
//# sourceMappingURL=ActionSelect.js.map